/**
 * Focus management for the two OEP dialogs. mj-slide-panel (Mode="dialog") owns the backdrop,
 * animation, Escape and backdrop-click close, but no role, focus move, trap or focus return
 * (ng-ui-components slide-panel.component.js: no focus/aria code), so the overlays add them.
 */
const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

/** Tab / Shift+Tab wrap inside `container` so focus cannot leave an open modal dialog. */
export function OEPTrapTab(event: KeyboardEvent, container: HTMLElement): void {
    if (event.key !== 'Tab') return;
    const items = Array.from(container.querySelectorAll<HTMLElement>(FOCUSABLE));
    if (items.length === 0) {
        // Nothing to tab to: keep focus on the dialog itself rather than letting it walk the page behind.
        event.preventDefault();
        container.focus();
        return;
    }
    const first = items[0];
    const last = items[items.length - 1];
    const active = container.ownerDocument.activeElement;
    if (event.shiftKey && (active === first || !container.contains(active))) {
        event.preventDefault();
        last.focus();
    } else if (!event.shiftKey && (active === last || !container.contains(active))) {
        event.preventDefault();
        first.focus();
    }
}

/** Hands focus back to the opener if it is still on the page, else to a stable connected fallback (e.g. the header bell). */
export function OEPRestoreFocus(opener: HTMLElement | null, fallback: HTMLElement | null = null): void {
    if (opener && opener.isConnected) opener.focus();
    else if (fallback && fallback.isConnected) fallback.focus();
}

/** The focused element at the moment a dialog opens (null when nothing but the page body has focus). */
export function OEPCaptureOpener(doc: Document): HTMLElement | null {
    const a = doc.activeElement;
    return a instanceof HTMLElement && a !== doc.body ? a : null;
}
